import React, { Fragment, useEffect, useState, useRef } from "react";
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getProjectList, getProjectActivitiesListData, getAccessableTaskList } from '../../../store/actions/ProjectActions';

const AddReportManual = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const startDateRef = useRef();
    const endDateRef = useRef();

    let errorsObj = { project: '', activity: '', task: '', startDate: '', endDate: '', desc: '', };
    const [errors, setErrors] = useState(errorsObj);

    const [project, setProject] = useState('');
    const [activity, setActivity] = useState('');
    const [task, setTask] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [description, setDescription] = useState('');
    const [recId, setRecId] = useState('');
    const [isProject, setIsProject] = useState(false);

    useEffect(() => {
        resetValue();
    }, [props.show]);

    useEffect(() => {
        dispatch(getProjectList('', '', '', 1, 0, props.systemAdmin, props.history));
    }, []);



    const resetValue = () => {
        const errorObj = { ...errorsObj };
        errorObj.project = '';
        errorObj.activity = '';
        errorObj.task = '';
        errorObj.startDate = '';
        errorObj.endDate = '';
        errorObj.desc = '';
        setErrors(errorObj);
        if (props.action === 1) {
            setRecId('');
            setProject('');
            setActivity('');
            setTask('');
            setStartDate('');
            setEndDate('');
            setDescription('');
            if (props.data?.project) {
                onProjectHandler(props.data?.project ?? '');
                setIsProject(true)
            }
        }
        // else {
        //     let startDate = new Date(props.data.start_date);
        //     let endDate = new Date(props.data.end_date);
        //     setProject(props.data.project_id);
        //     setId(props.data.activity_id);
        //     setTitle(props.data.title);
        //     setDescription(props.data.description);
        //     setStartDate(startDate);
        //     setEndDate(endDate);
        //     setActivitiesId(props.data._id);
        //     setStatus(props.data.status);
        // }
    }

    function onSubmit(e) {

        e.preventDefault();

        let error = false;
        const errorObj = { ...errorsObj };
        if (project === '') {
            errorObj.project = 'Project is Required';
            error = true;
        }
        if (activity === '') {
            errorObj.activity = 'Activity is Required';
            error = true;
        }
        if (task === '') {
            errorObj.task = 'Task is Required';
            error = true;
        }
        if (startDate === '') {
            errorObj.startDate = 'Start Date is Required';
            error = true;
        }
        if (endDate === '') {
            errorObj.endDate = 'End Date is Required';
            error = true;
        }
        if (description === '') {
            errorObj.desc = 'Description is Required';
            error = true;
        }
        setErrors(errorObj);
        if (error) {
            return;
        }

        let obj = {
            'project': project,
            'activity': activity,
            'task': task,
            'startDate': startDate,
            'endDate': endDate,
            'description': description,
        };
        props.submitHandler(obj);

    }

    const onProjectHandler = (val) => {
        setProject(val);
        setActivity('');
        setTask('');
        if (val) {
            dispatch(getProjectActivitiesListData(val, '', '', '', 1, 0, props.systemAdmin, props.history));
        }
    }

    const onActivityHander = (val) => {
        setActivity(val);
        setTask('');
        dispatch(getAccessableTaskList(val, props.systemAdmin ? "" : props.userId, props.history));
    }


    return (
        <Fragment>
            <Modal
                className="fade bd-example-modal-sm"
                size="lg"
                onHide={props.closeHandler}
                show={props.show}
            >
                <div className="add-user-modal-form-view">
                    <button onClick={props.closeHandler} className="modal-cross-btn"><i class="fa fa-times" aria-hidden="true"></i></button>
                    <div className="modal-title-view">
                        <h3>{props.action == 1 ? 'Create' : 'Edit'} Manual Entry</h3>
                        <p>Enter Time capture Details</p>
                    </div>
                    <div className="basic-form">

                        <div className="basic-form">
                            <form onSubmit={onSubmit}>

                                <div className="row">

                                    <div className="form-group form-group-modal-custom mb-3 col-6">
                                        <label className="mb-1">
                                            Project
                                        </label>
                                        <div className="select-drop-down">
                                            <span><i class="fa fa-angle-down"></i></span>
                                            <select
                                                defaultValue={"option"}
                                                class="form-control select-control"
                                                value={project}
                                                disabled={isProject}
                                                onChange={(e) => onProjectHandler(e.target.value)}>
                                                <option></option>
                                                {
                                                    props.projectList.map((item, index) => {
                                                        return <option key={index} value={item._id}>{item.title}</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                        {errors.project && <div className="text-danger fs-12">{errors.project}</div>}
                                    </div>
                                    <div className="form-group form-group-modal-custom mb-3 col-6">
                                        <label className="mb-1">
                                            Activity
                                        </label>
                                        <div className="select-drop-down">
                                            <span><i class="fa fa-angle-down"></i></span>
                                            <select
                                                defaultValue={"option"}
                                                className="form-control select-control"
                                                value={activity}
                                                onChange={(e) => onActivityHander(e.target.value)}>
                                                <option value=""></option>
                                                {
                                                    props.activitiesList.map((item, index) => {
                                                        return <option key={index} value={item._id}>{item.activity_id}</option>
                                                    })
                                                }
                                            </select>
                                            {errors.activity && <div className="text-danger fs-12">{errors.activity}</div>}
                                        </div>
                                    </div>

                                    <div className="form-group form-group-modal-custom mb-3 col-6">
                                        <label className="mb-1">
                                            Task
                                        </label>
                                        <div className="select-drop-down">
                                            <span><i class="fa fa-angle-down"></i></span>
                                            <select
                                                defaultValue={"option"}
                                                className="form-control select-control"
                                                value={task}
                                                onChange={(e) => setTask(e.target.value)}>
                                                <option value=""></option>
                                                {
                                                    props.taskList.map((item, index) => {
                                                        return <option key={index} value={item._id}>{item.task_id}</option>
                                                    })
                                                }
                                            </select>
                                            {errors.task && <div className="text-danger fs-12">{errors.task}</div>}
                                        </div>
                                    </div>

                                    <div className="form-group form-group-modal-custom mb-3 col-6">
                                        <label className="mb-1">
                                            Start Date
                                        </label>
                                        <div className="form-calendar">
                                            <DatePicker
                                                ref={startDateRef}
                                                selected={startDate}
                                                onChange={(date) => setStartDate(date)}
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                timeIntervals={15}
                                                dateFormat="MM/dd/yyyy HH:mm"
                                                timeCaption="Time (24hr)"
                                                className="form-control"
                                            />


                                            <button type='button' className="form-calendar-btn"
                                                onClick={() => startDateRef.current.setOpen(true)}
                                            >
                                                <i class="fa-regular fa-calendar-days"></i>
                                            </button>
                                        </div>
                                        {errors.startDate && <div className="text-danger fs-12">{errors.startDate}</div>}
                                    </div>

                                    <div className="form-group form-group-modal-custom mb-3 col-6">
                                        <label className="mb-1">
                                            End Date
                                        </label>
                                        <div className="form-calendar">
                                            <DatePicker
                                                ref={endDateRef}
                                                selected={endDate}
                                                onChange={(date) => setEndDate(date)}
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                timeIntervals={15}
                                                dateFormat="MM/dd/yyyy HH:mm"
                                                timeCaption="Time (24hr)"
                                                className="form-control"

                                            />
                                            <button type='button' className="form-calendar-btn"
                                                onClick={() => endDateRef.current.setOpen(true)}
                                            >
                                                <i class="fa-regular fa-calendar-days"></i>
                                            </button>
                                        </div>
                                        {errors.endDate && <div className="text-danger fs-12">{errors.endDate}</div>}
                                    </div>

                                    <div className="form-group form-group-modal-custom mb-3 col-6">
                                        <label className="mb-1">
                                            Description
                                        </label>
                                        <input className="form-control" value={description} onChange={(e) => setDescription(e.target.value)} />
                                        {errors.desc && <div className="text-danger fs-12">{errors.desc}</div>}
                                    </div>

                                </div>

                                <div className="modal-button-group mt-4">
                                    <button type="button" onClick={props.closeHandler} className="btn form-cencel-btn">
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary role-form-btn">
                                        {props.action == 1 ? "Save" : "Update"}
                                    </button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </Modal>
        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        teamLoading: state.team.showLoading,
        activeTeamList: state.team.activeTeamList,
        clientLoading: state.clients.showLoading,
        clientList: state.clients.clientList,
        projectList: state.project.projectList,
        activitiesList: state.project.activitiesList,
        taskList: state.project.taskList,
        systemAdmin: state.auth.systemAdmin,
        userId: state.auth.userId,
    };
};
export default connect(mapStateToProps)(AddReportManual);